import { IndexableObject } from '../types/ObjectTypes';

type TypeDescriptor = { optional: boolean; type: string };

export interface ChainablePropType {
  (
    props: IndexableObject,
    propName: string,
    componentName: string,
    ...rest: any[]
  ): Error | null;
  isRequired?: ChainablePropType;
  getType?: () => TypeDescriptor;
}

// Factory for the .required version of the propType function.
// See https://www.ian-thomas.net/custom-proptype-validation-with-react/
export default function createChainablePropType(
  validate: ChainablePropType,
  __propTypeName: string,
  __args: Record<string, any> = {}
) {
  function checkType(
    isRequired: boolean,
    props: IndexableObject,
    propName: string,
    componentName: string,
    ...rest: any[]
  ) {
    if (props[propName] == null) {
      if (isRequired) {
        return new Error(
          `Required prop \`${propName}\` was not specified in \`${componentName}\`.`
        );
      }
      return null;
    }
    return validate(props, propName, componentName, ...rest);
  }

  const chainedCheckType: ChainablePropType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}
